import { DeviceTaskType } from "../IDevice";
import { DeviceControlFeature } from "../IDeviceTask";
import { DeviceTask } from "./DeviceTask";

export class SetTemperature extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetTemperature;
        this.TaskType = DeviceTaskType.SetTemperature;
    }

    Temperature: number = 0;
}

export class TurnOff extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.TurnOff;
        this.TaskType = DeviceTaskType.TurnOff;
    }
}

export class TurnOn extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.TurnOn;
        this.TaskType = DeviceTaskType.TurnOn;
    }
}

export class TurnOnWithTime extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.TurnOnWithTimeout;
        this.TaskType = DeviceTaskType.TurnOnWithTime;
    }
    
    SwitchOffDelaySeconds: number = 0;
}

export class SetLightBrightness extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetLightBrightness;
        this.TaskType = DeviceTaskType.SetLightBrightness;
    }

    Brightness: number = 0;
}

export class ToggleState extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.ToggleState;
        this.TaskType = DeviceTaskType.TogleState;
    }
}

export class SetLightColor extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetLightColor;
        this.TaskType = DeviceTaskType.SetLightColor;
    }

    R: number = 0;
    G: number = 0;
    B: number = 0;
}

export class SetLightTemperature extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetLightTemperature;
        this.TaskType = DeviceTaskType.SetLightTemperature;
    }

    Temperature: number = 0;
}

export class SetBlindPosition extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetBlindPosition;
        this.TaskType = DeviceTaskType.SetBlindPosition;
    }

    Action: BlindActionEnum = BlindActionEnum.Stop;
    Position: number = 0;
}

export enum BlindActionEnum {
    Open = 0,
    Close = 1,
    Stop = 2,
    Percentage = 3
}

export class SetGatePositionPrecise extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetGatePositionPrecise;
        this.TaskType = DeviceTaskType.PreciseGateControl;
    }

    GateControlAction: GateActionEnum = GateActionEnum.Stop;
    Position: number = 0;
}


export class SetGatePositionPreciseSecure extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetGatePositionPreciseSecure;
        this.TaskType = DeviceTaskType.PreciseGateControlSecure;
    }

    GateControlAction: GateActionEnum = GateActionEnum.Stop;
    Position: number = 0;
    Pin: string = "";
}

export enum GateActionEnum {
    Open = 0,
    Close = 1,
    Stop = 2,
    Percentage = 3
}

export class SetBlindPositionSimple extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetBlindPosition;
        this.TaskType = DeviceTaskType.SetBlindPositionSimple;
    }

    Action: BlindActionSimpleEnum = BlindActionSimpleEnum.Stop;
    Position: number = 0;
}

export enum BlindActionSimpleEnum {
    Open = 0,
    Close = 1,
    Stop = 2,
}

export class SetLightBrightnessDynamicly extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetLightBrightnessDynamicly;
        this.TaskType = DeviceTaskType.SetLightBrightnessDynamicly;
    }

    Brightness: number = 0;
}

export class IdentifyDevice extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.IdentifyDevice;
        this.TaskType = DeviceTaskType.IdentifyDevice;
    }
}

export class SetBlindOpenCloseTime extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetBlindOpenCloseTime;
        this.TaskType = DeviceTaskType.SetBlindOpenCloseTime;
    }

    Data: BlindOpenCloseTimeData = new BlindOpenCloseTimeData();
}

export class BlindOpenCloseTimeData {
    Channel: number = 0;
    CloseTime: number = 0;
    OpenTime: number = 0;
}

export class GetDeviceState extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GetState;
        this.TaskType = DeviceTaskType.GetChannelsState;
    }
}

export class SetBlindMicroventilation extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetBlindMicroventilation;
        this.TaskType = DeviceTaskType.SetBlindMicroventilation;
    }

    Position: number = 0;
}

export class ChangeGatePositionPulse extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GatePulse;
        this.TaskType = DeviceTaskType.ChangeGatewayPositionPulse;
    }
}

export class ChangeGatewayPositionPulse extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GatewayPulse;
        this.TaskType = DeviceTaskType.ChangeGatewayPositionPulse;
    }
}

export class SetFacadePosition extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.SetFacadePositionAndTilt;
        this.TaskType = DeviceTaskType.SetFacadePosition;
    }

    FacadeAction: FacadeActionEnum = FacadeActionEnum.Stop;
    Tilt: number = 0;
    Position: number = 0;
}

export class GetFacadeType extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.GetFacadeType;
        this.TaskType = DeviceTaskType.GetFacadeType;
    }
}

export enum FacadeActionEnum {
    Open = 0,
    Close = 1,
    Stop = 2,
    Percentage = 3,
    Tilt = 4,
    TiltAndPercentage = 5
}

export class LightRGBWData
{
    R: number = 0;
    G: number = 0;
    B: number = 0;
    W: number = 0;
    Brightness: number = 0;
    Channel: number = 0;
}

export class LightRGBW extends DeviceTask {
    constructor() {
        super();
        this.FeatureType = DeviceControlFeature.LightRGBW;
        this.TaskType = DeviceTaskType.LightRGBW;
    }
    
    Data: LightRGBWData = new LightRGBWData();
}